import { twMerge } from "tailwind-merge";

type Options = readonly [
  {
    label: string;
    value: string;
  },
  ...{
    label: string;
    value: string;
  }[],
];

interface ToggleProps<T extends Options> {
  options: T;
  value: T[number]["value"];
  onClick: (val: T[number]["value"]) => void;
}

export const Toggle = <T extends Options>({
  options,
  value,
  onClick,
}: ToggleProps<T>) => (
  <div className="flex flex-row gap-2 rounded-lg bg-surface-container-high p-2 dark:bg-surface-container-high-dark">
    {options.map((option) => {
      const isSelected = option.value === value;
      return (
        <button
          key={option.value}
          className={twMerge(
            isSelected
              ? "bg-neutral-variant-90 text-surface-container-low-dark"
              : "bg-surface-container-high text-neutral-variant-60 dark:bg-surface-container-high-dark dark:text-neutral-variant-80",
            "rounded-lg p-2",
          )}
          onClick={() => onClick(option.value)}
        >
          {option.label}
        </button>
      );
    })}
  </div>
);
